import { useTranslation } from 'react-i18next'
import { useNavigate, useLocation, Link } from 'react-router-dom'
import { Box, Typography } from '@mui/material'
import ExitToAppIcon from '@mui/icons-material/ExitToApp'

import theme from 'lib/theme'
import SecondarySidebar from 'components/SecondarySidebar/SecondarySidebar'
import { useAuth } from 'providers/AuthProvider'
import { SidebarLinkWrapper } from './Place.styled'

export const PlaceSecondarySidebar = ({
  placeId,
  placeName,
  placeMasterId,
}: {
  placeId: string
  placeName: string
  placeMasterId: string
}) => {
  const { userRoles } = useAuth()
  const placeAdmin = userRoles.includes('placeadmin')
  const { t } = useTranslation()
  const location = useLocation()
  const navigate = useNavigate()
  const prevListingPage = localStorage.getItem('placesListingPage')

  const generalOptions = [
    { key: 'info', value: t('info') },
    { key: 'contact', value: t('contacts') },
    { key: 'extensions', value: t('extensions') },
    ...(placeAdmin ? [{ key: 'payment', value: t('payment') }] : []),
  ]
  const fulfilmentOptions = [
    { key: 'fulfilment', value: t('fulfilmentSettings') },
    { key: 'serviceAreas', value: t('serviceAreas') },
  ]

  return (
    <SecondarySidebar
      header={placeName}
      subtitle={`ID ${placeMasterId}`}
      onGoBackClick={() => navigate(`/place${prevListingPage}`)}>
      <Typography
        variant='body2'
        mb={2}
        mt={2}
        sx={{ color: theme.palette.text.secondary }}>
        {t('general').toUpperCase()}
      </Typography>
      {generalOptions.map((option) => (
        <SidebarLinkWrapper
          key={option.key}
          optionKey={option.key}
          location={location.pathname.split('/')[3]}>
          <Link
            style={{
              textDecoration: 'none',
              color:
                option.key.toLowerCase() === location.pathname.split('/')[3]
                  ? theme.palette.primary.main
                  : theme.palette.commonColors.black,
              width: '100%',
              height: '26px',
              display: 'flex',
              alignItems: 'center',
            }}
            to={`/place/${placeId}/${option.key}`}>
            <Typography variant='body2' ml={4}>
              {option.value}
            </Typography>
          </Link>
        </SidebarLinkWrapper>
      ))}
      <Typography
        variant='body2'
        mt={3}
        sx={{ color: theme.palette.text.secondary }}>
        {t('fulfilment').toUpperCase()}
      </Typography>
      {fulfilmentOptions.map((option) => {
        return option.value === t('serviceAreas') ? (
          <SidebarLinkWrapper
            key={option.key}
            optionKey={option.key}
            location={location.pathname.split('/')[3]}>
            <Link
              style={{
                textDecoration: 'none',
                color:
                  option.key.toLowerCase() === location.pathname.split('/')[3]
                    ? theme.palette.primary.main
                    : theme.palette.commonColors.black,
                width: '223px',
                height: '26px',
                display: 'flex',
                alignItems: 'center',
              }}
              to={`/place/${placeMasterId}/service-areas`}>
              <Box display='flex' alignItems='center'>
                <ExitToAppIcon />
                <Typography variant='body2' ml={1}>
                  {option.value}
                </Typography>
              </Box>
            </Link>
          </SidebarLinkWrapper>
        ) : (
          <SidebarLinkWrapper
            key={option.key}
            optionKey={option.key}
            location={location.pathname.split('/')[3]}>
            <Link
              style={{
                textDecoration: 'none',
                color: theme.palette.commonColors.black,
                width: '223px',
                height: '26px',
                display: 'flex',
                alignItems: 'center',
              }}
              to={`/place/${placeMasterId}/fulfilment`}>
              <Typography variant='body2' pl={4}>
                {option.value}
              </Typography>
            </Link>
          </SidebarLinkWrapper>
        )
      })}
    </SecondarySidebar>
  )
}
